// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 229) return "../css/7.0.35251-app-legacy-sectioned-content.min.css";
	if (chunkId === 632) return "../css/7.0.35251-app-legacy-reviews.min.css";
	if (chunkId === 462) return "../css/7.0.35251-app-legacy-sr-fleet-register-button.min.css";
	// return url for filenames based on template
	return undefined;
};